import React from "react";
import FilterField2Dropdown from "core/manager/filters/filter-fields3/dropdown";

export default class FilterField2Multiselect extends FilterField2Dropdown {

    filterFuncUniversal(model) {
        if (!this.value) return true; //null;

        const fieldValue = model[this.filterConfig.fieldId]
        if (!fieldValue) {
            return this.value.includes(null);
        }

        return this.value.some(val => fieldValue.includes(val));
    }
}